/** Small shared pieces of the Agents panes. Theme variables only (see ../jobs/ui). */
import type { CSSProperties } from 'react'
import type { Cycle, RunState } from './contract'
import { C, Chip } from '../jobs/ui'

const TONE: Record<RunState, 'ok' | 'err' | 'warn' | 'info' | 'muted' | 'accent'> = {
  queued: 'info', running: 'accent', waiting_human: 'warn', waiting_event: 'warn',
  paused: 'muted', suspended: 'err', completed: 'ok', failed: 'err', cancelled: 'muted',
}

export function RunStateChip({ state, label }: { state: RunState; label?: string }) {
  return <Chip tone={TONE[state] || 'muted'}>{label || state.replace('_', ' ')}</Chip>
}

export function credits(n: number | null | undefined): string {
  const v = Number(n || 0)
  return v >= 100 ? v.toFixed(0) : v >= 10 ? v.toFixed(1) : v.toFixed(2)
}

export function smallBtn(primary = false): CSSProperties {
  return {
    height: 30, padding: '0 12px', borderRadius: 7, fontSize: '0.875rem', fontWeight: 600,
    cursor: 'pointer', border: `1px solid ${primary ? C.accent : C.line}`,
    background: primary ? C.accent : 'transparent', color: primary ? '#fff' : C.ink,
  }
}

const DAYS = ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun']

export function describeCycle(c: Cycle | null | undefined): string {
  if (!c || c.type === 'manual') return 'Only when started'
  const at = c.time ? ` at ${c.time}` : ''
  const tz = c.timezone && c.timezone !== 'UTC' ? ` ${c.timezone}` : c.time ? ' UTC' : ''
  switch (c.type) {
    case 'daily': return `Every day${at}${tz}`
    case 'weekly': return `Every ${(c.days || []).map((d) => d.slice(0, 1).toUpperCase() + d.slice(1)).join(', ') || 'week'}${at}${tz}`
    case 'monthly': return `Monthly on day ${c.day_of_month || 1}${at}${tz}`
    case 'interval': return `Every ${c.interval_value || 1} ${c.interval_unit || 'hours'}`
    case 'cron': return `Cron ${c.cron_expression || ''}`
    default: return c.type
  }
}

export const CYCLE_DAYS = DAYS

export function BudgetBar({ spent, budget }: { spent: number; budget: number }) {
  const pct = budget ? Math.min(100, (spent / budget) * 100) : 0
  return (
    <div title={`${credits(spent)} of ${credits(budget)} credits this cycle`}
      style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 140 }}>
      <div style={{ flex: 1, height: 6, background: C.s2, borderRadius: 3 }}>
        <div style={{ width: `${pct}%`, height: '100%', borderRadius: 3,
          background: pct > 90 ? C.err : pct > 70 ? C.warn : C.accent }} />
      </div>
      <span style={{ fontSize: '0.8125rem', color: C.ink2, whiteSpace: 'nowrap' }}>
        {credits(spent)} / {credits(budget)}
      </span>
    </div>
  )
}
